import { getActiveRoleRequestHeaders } from "@/lib/utils/api/active-role-header";
import { resolveOpenApiBasePath } from "@/lib/utils/api/openapi-configuration";
import { getEffectiveTenantApiHeaders } from "@/lib/utils/env/effective-tenant";

export type StaffOnlinePerson = {
  userId: number;
  firstName: string;
  lastName: string;
  role: string | null;
};

export function staffOnlineOthers(
  people: readonly StaffOnlinePerson[] | null | undefined,
  currentUserId: number | undefined,
): StaffOnlinePerson[] {
  if (!people?.length) return [];
  if (currentUserId == null) return [...people];
  return people.filter((person) => person.userId !== currentUserId);
}

function staffOnlineUrl(): string {
  return `${resolveOpenApiBasePath()}/api/staff-online`;
}

function headers(accessToken: string, json = false): HeadersInit {
  return {
    ...getEffectiveTenantApiHeaders(),
    ...getActiveRoleRequestHeaders(),
    Authorization: `Bearer ${accessToken}`,
    ...(json ? { "Content-Type": "application/json" } : {}),
  };
}

/** False when this API does not have the online endpoint yet. */
export async function sendStaffOnlineHeartbeat(
  accessToken: string,
  role: string | null,
): Promise<boolean> {
  const response = await fetch(staffOnlineUrl(), {
    method: "PUT",
    headers: headers(accessToken, true),
    body: JSON.stringify({ role }),
  });

  if (response.status === 404 || response.status === 405) return false;
  return response.ok;
}

/** Null when this API does not have the online endpoint yet. */
export async function fetchStaffOnline(
  accessToken: string,
): Promise<StaffOnlinePerson[] | null> {
  const response = await fetch(staffOnlineUrl(), {
    headers: headers(accessToken),
  });

  if (response.status === 404 || response.status === 405) return null;
  if (!response.ok) {
    throw new Error("Staff online list could not be loaded.");
  }

  const body = (await response.json()) as StaffOnlinePerson[];
  return Array.isArray(body) ? body : [];
}
